import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
  type ISourceEntity,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard, type Timezone } from '@principle-theorem/shared';
import { isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const APPOINTMENT_TAG_RESOURCE_TYPE = 'appointmentTag';

export const APPOINTMENT_TAG_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Appointment Tag List',
    description: '',
    idPrefix: APPOINTMENT_TAG_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ICorePracticeAppointmentTag {
  tag: string;
}

export function isCorePracticeAppointmentTag(
  item: unknown,
  logError: boolean
): item is ICorePracticeAppointmentTag {
  return TypeGuard.interface<ICorePracticeAppointmentTag>(
    {
      tag: isString,
    },
    logError
  )(item);
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticeAppointmentTagTranslations {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICorePracticeAppointmentTagFilters {}

/**
 * Appointment tags are stored on the source `AppointmentDetail` table as a
 * comma-delimited string per appointment. This query splits and de-duplicates
 * them at the database so the mapping UI reads one record per distinct tag,
 * instead of scanning the entire appointment-details table in the browser.
 */
const APPOINTMENT_TAG_SOURCE_QUERY = `
SELECT DISTINCT
  trim(source_tag.value) AS tag
FROM AppointmentDetail
CROSS JOIN LATERAL unnest(string_to_array(tags, ',')) AS source_tag(value)
WHERE trim(source_tag.value) <> ''
`;

export type CorePracticeAppointmentTag = ISourceEntityTypes<
  ICorePracticeAppointmentTag,
  ICorePracticeAppointmentTagTranslations,
  ICorePracticeAppointmentTagFilters
>;

export class AppointmentTagSourceEntity extends BaseSourceEntity<CorePracticeAppointmentTag> {
  sourceEntity = APPOINTMENT_TAG_SOURCE_ENTITY;
  entityResourceType = APPOINTMENT_TAG_RESOURCE_TYPE;
  sourceQuery = APPOINTMENT_TAG_SOURCE_QUERY;
  verifySourceFn = isCorePracticeAppointmentTag;

  translate(_data: ICorePracticeAppointmentTag, _timezone: Timezone): object {
    return {};
  }

  getSourceRecordId(data: ICorePracticeAppointmentTag): string {
    return data.tag;
  }

  getSourceLabel(data: ICorePracticeAppointmentTag): string {
    return data.tag;
  }

  getFilterData(
    _data: ICorePracticeAppointmentTag,
    _timezone: Timezone
  ): object {
    return {};
  }
}
